import axios from "axios";
const API_URL = process.env.VUE_APP_API_BASE_POINT;
const API_URL_AFFILIATE = process.env.VUE_APP_API_BASE_POINT_AFFILIATE;

// create a new axios instance
const axiosInstance = axios.create({
  baseURL: API_URL,
});

const axiosInstanceCoupon = axios.create({
  baseURL: API_URL_AFFILIATE,
});

export default axiosInstance;
export { axiosInstanceCoupon };

